<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Nieuwe klant toevoegen">
            <b-form @submit.prevent="submitForm">
              <b-row>
                <b-col cols="12">
                  <h5>Basisgegevens</h5>
                  <hr>
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group label="Naam">
                    <b-form-input type="text" required v-model="Customer.name"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12">
                  <h5>Contactgegevens</h5>
                  <hr>
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group label="E-mailadres">
                    <b-form-input type="email" required v-model="Customer.email"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12">
                  <h5>Bedrijfsgegevens</h5>
                  <hr>
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group label="Bedrijf">
                    <company-select :options="companies" v-model="Customer.company_id" :pre-populate="false" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <hr />
                  <b-button type="submit" variant="success" class="pull-right" :disabled="loading">
                    <b-spinner v-show="loading" small type="grow" />
                    Opslaan
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { getData, storeData } from '../../api';
import CompanySelect from "../../components/CompanySelect";

export default {
  name: 'new-customer',
  components: { CompanySelect },
  data() {
    return {
      loading: false,
      companies: [],
      Customer: {
        name: null,
        email: null,
        company_id: null,
      },
    };
  },
  methods: {
    async getCompaniesData() {
      return await getData('companies?per_page=9999').then(({ data }) => {
        this.companies = data.data.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      });
    },
    submitForm() {
      this.loading = true;

      const data = {
        ...this.Customer,
        // password: this.Customer.email
      };


      storeData('customers', data)
        .then(({ data }) => {
          this.loading = false;
          this.$router.push({
            name: 'customers.view',
            params: { id: data.data.id },
          });
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
  beforeMount() {
    this.getCompaniesData();
  },
};

</script>
